import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";

export default function SicBo() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "sicbo";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const dicePairs = [
    [1, 2],
    [1, 3],
    [1, 4],
    [1, 5],
    [1, 6],
    [2, 3],
    [2, 4],
    [2, 5],
    [2, 6],
    [3, 4],
    [3, 5],
    [3, 6],
    [4, 5],
    [4, 6],
    [5, 6],
  ];

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      // gameName={"CARDS 32B"}
    >
      <div className="casino-detail">
        <div className="casino-table">
          {/* <div className="d-none d-xl-block"> */}
          <div className="">
            <div className="sicbo-top">
              <div className="sicbo-top-box sicbo-title-box ">
                1:1 Lose to Any Triple
              </div>
              <div className="sicbo-top-box sicbo-title-box">30:1</div>
              <div className="sicbo-top-box sicbo-title-box">
                1:1 Lose to Any Triple
              </div>
            </div>
            <div className="sicbo-middle">
              <div
                className={`sicbo-middle-small sicbo-square-box ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[0]?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <div>
                  {casinoData?.data?.response?.oddDetailsDTOS?.[0]?.runnerName}
                </div>
                <div className="sicbo-box-value">4-10</div>
              </div>
              <div className="sicbo-middle-midle">
                <div className="sicbo-middle-top-row">
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[3]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>
                      {
                        casinoData?.data?.response?.oddDetailsDTOS?.[3]
                          ?.runnerName
                      }
                    </div>
                    <div className="sicbo-box-value ">1:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[17]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>4</div>
                    <div className="sicbo-box-value ">50:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[18]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>5</div>
                    <div className="sicbo-box-value ">20:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[19]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>6</div>
                    <div className="sicbo-box-value ">15:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[20]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>7</div>
                    <div className="sicbo-box-value ">12:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[21]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>8</div>
                    <div className="sicbo-box-value ">8:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[22]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>9</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[23]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>10</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>

                  <div
                    className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[2]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>
                      {
                        casinoData?.data?.response?.oddDetailsDTOS?.[2]
                          ?.runnerName
                      }
                    </div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[24]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>11</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[25]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>12</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[26]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>13</div>
                    <div className="sicbo-box-value ">8:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[27]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>14</div>
                    <div className="sicbo-box-value ">12:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[28]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>15</div>
                    <div className="sicbo-box-value ">15:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[29]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>16</div>
                    <div className="sicbo-box-value ">20:1</div>
                  </div>
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[30]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>17</div>
                    <div className="sicbo-box-value ">50:1</div>
                  </div>

                  <div
                    className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[4]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>
                      {
                        casinoData?.data?.response?.oddDetailsDTOS?.[4]
                          ?.runnerName
                      }
                    </div>
                    <div className="sicbo-box-value ">1:1</div>
                  </div>
                </div>
                <div className="sicbo-middle-middle-row">
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      <span>1:1 on Sinlge</span>
                      <span>2:1 on Double</span>
                      <span>3:1 on Tripple</span>
                    </div>
                    <div className="sicbo-cube-box-group">
                      {casinoData?.data?.response?.oddDetailsDTOS
                        ?.slice(46, 52)
                        ?.map((item, index) => (
                          <div
                            key={index}
                            className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${
                              casinoData?.data?.response?.autoTime < 5
                                ? "suspended-box"
                                : ""
                            }`}
                            onClick={() =>
                              setBet(
                                item?.runnerName,
                                casinoData,
                                dispatch,
                                "back"
                              )
                            }
                          >
                            <img
                              src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${index +
                                1}.png`}
                              alt={`Dice ${index + 1}`}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      8:1 Double
                    </div>
                    <div className="sicbo-cube-box-group">
                      {casinoData?.data?.response?.oddDetailsDTOS
                        ?.slice(5, 11)
                        ?.map((item, index) => (
                          <div
                            key={index}
                            className={`sicbo-cube-box sicbo-square-box sicbo-cube-double ${
                              casinoData?.data?.response?.autoTime < 5
                                ? "suspended-box"
                                : ""
                            }`}
                            onClick={() =>
                              setBet(
                                item?.runnerName,
                                casinoData,
                                dispatch,
                                "back"
                              )
                            }
                          >
                            <img
                              src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${index +
                                1}.png`}
                              alt={`Dice ${index + 1}`}
                            />
                            <img
                              src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${index +
                                1}.png`}
                              alt={`Dice ${index + 1}`}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      150:1 Each Tripple
                    </div>
                    <div className="sicbo-cube-box-group">
                      {casinoData?.data?.response?.oddDetailsDTOS
                        ?.slice(11, 17)
                        ?.map((item, index) => (
                          <div
                            key={index}
                            className={`sicbo-cube-box sicbo-square-box sicbo-cube-tripple ${
                              casinoData?.data?.response?.autoTime < 5
                                ? "suspended-box"
                                : ""
                            }`}
                            onClick={() =>
                              setBet(
                                item?.runnerName,
                                casinoData,
                                dispatch,
                                "back"
                              )
                            }
                          >
                            <img
                              src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${index +
                                1}.png`}
                              alt={`Dice ${index + 1}`}
                            />
                            <img
                              src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${index +
                                1}.png`}
                              alt={`Dice ${index + 1}`}
                            />
                            <img
                              src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${index +
                                1}.png`}
                              alt={`Dice ${index + 1}`}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`sicbo-middle-big sicbo-square-box ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <div>
                  {casinoData?.data?.response?.oddDetailsDTOS?.[1]?.runnerName}
                </div>
                <div className="sicbo-box-value">11-17</div>
              </div>
            </div>
            <div className="sicbo-bottom">
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">
                  5:1 Two Dice
                </div>
                <div className="sicbo-cube-box-group">
                  {/* <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                      alt="Dice 1"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                      alt="Dice 2"
                    />
                  </div> */}
                  {casinoData?.data?.response?.oddDetailsDTOS
                    ?.slice(31, 46)
                    ?.map((item, index) => {
                      const [die1, die2] = dicePairs[index];
                      return (
                        <div
                          key={index}
                          className={`sicbo-cube-box sicbo-square-box sicbo-cube-combination ${
                            casinoData?.data?.response?.autoTime < 5
                              ? "suspended-box"
                              : ""
                          }`}
                          onClick={() =>
                            setBet(
                              item?.runnerName,
                              casinoData,
                              dispatch,
                              "back"
                            )
                          }
                        >
                          <img
                            src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${die1}.png`}
                            alt={`Dice ${die1}`}
                          />
                          <img
                            src={`https://g1ver.sprintstaticdata.com/v50/static/front/img/dice${die2}.png`}
                            alt={`Dice ${die2}`}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="d-xl-none w-100">
            <div className="sicbo-top">
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">
                  1:1 Lose to Any Triple
                </div>
                <div className="sicbo-cube-box-group">
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Small</div>
                    <div className="sicbo-box-value">4-10</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>ODD</div>
                    <div className="sicbo-box-value">1:1</div>
                  </div>
                </div>
              </div>
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">30:1</div>
                <div className="sicbo-cube-box-group">
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Any Triple</div>
                  </div>
                </div>
              </div>
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">
                  1:1 Lose to Any Triple
                </div>
                <div className="sicbo-cube-box-group">
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Even</div>
                    <div className="sicbo-box-value ">1:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Big</div>
                    <div className="sicbo-box-value ">11:17</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sicbo-middle">
              <div className="sicbo-middle-left">
                <div className="sicbo-cube-box-container">
                  <div className="sicbo-top-box sicbo-title-box">
                    8:1 Each Double
                  </div>
                  <div className="sicbo-cube-box-group">
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                    </div>
                  </div>
                </div>
                <div className="sicbo-cube-box-container">
                  <div className="sicbo-top-box sicbo-title-box">
                    150:1 Each Tripple 
                  </div>
                  <div className="sicbo-cube-box-group">
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="sicbo-middle-right">
                <div className="sicbo-middle-top-row">
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>4</div>
                    <div className="sicbo-box-value ">50:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>5</div>
                    <div className="sicbo-box-value ">20:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>6</div>
                    <div className="sicbo-box-value ">15:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>7</div>
                    <div className="sicbo-box-value ">12:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>8</div>
                    <div className="sicbo-box-value ">8:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>9</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>10</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>11</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>12</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>13</div>
                    <div className="sicbo-box-value ">8:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>14</div>
                    <div className="sicbo-box-value ">12:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>15</div>
                    <div className="sicbo-box-value ">15:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>16</div>
                    <div className="sicbo-box-value ">20:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>17</div>
                    <div className="sicbo-box-value ">50:1</div>
                  </div>
                </div>
                <div className="sicbo-bottom">
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      5:1 Two Dice
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sicbo-middle-middle-row">
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      <span>1:1 on Sinlge</span>
                      <span>2:1 on Double</span>
                      <span>3:1 on Tripple</span>
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/sicbo">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result">6</span>
              <span className="result">14</span>
              <span className="result">8</span>
              <span className="result">11</span>
              <span className="result">7</span>
              <span className="result">7</span>
              <span className="result">8</span>
              <span className="result">7</span>
              <span className="result">16</span>
              <span className="result">11</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar sticky">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
